import React from 'react';
import AppRouter from './router/AppRouter';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './authentication/components/AuthProvider';
import { I18nProvider } from './i18n/I18nProvider';
import ScrollToTop from './core/components/Common/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';

const App = () => {
  return (
    <HelmetProvider>
      <I18nProvider>
        <AuthProvider>
          <Router>
            <ScrollToTop />
            <AppRouter />
          </Router>
        </AuthProvider>
      </I18nProvider>
    </HelmetProvider>
  );
};

export default App;